'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var commandBus = require('./command-bus.js');
var eventBus = require('./event-bus.js');
var queryBus = require('./query-bus.js');

const getGlobal = function() {
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw new Error("unable to locate global object");
};
getGlobal().eventBus = new eventBus.EventBus();
getGlobal().queryBus = new queryBus.QueryBus();
getGlobal().commandBus = new commandBus.CommandBus();

exports.getGlobal = getGlobal;
